#import "../fragments/prospector-saved-filter-fragment.graphql"

mutation UpdateFilter($input: FilterUpdateInput!) {
    filterUpdate(input: $input) {
        filter {
            ...ProspectorSavedFilterFragment
        }
    }
}
